import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {
	Artist,
	ArtistRelease,
	ArtistTopTracks,
	ArtistTopPlaylists,
	FanSegmentation,
	GetArtistReleasesParams,
} from './types';
import type {
	DataResponseWrapper,
	PaginatedGet,
	AnalyticFilters,
} from '@deezer/next/services/api/Starmania/requests/types';

const {get, paginatedGet} = requestWrapper;

const requests = {
	get: (id: string) =>
		get<DataResponseWrapper<Artist>>(endpoints.artistById(id)),
	getFanbaseSegmentation: (id: string) =>
		get<DataResponseWrapper<FanSegmentation | null>>(
			endpoints.artistFanSegmentation(id),
		),
	getReleases: (
		id: string,
		params?: GetArtistReleasesParams,
	): PaginatedGet<ArtistRelease[]> =>
		paginatedGet<ArtistRelease[]>(endpoints.releases(id), {
			params: {
				releaseType: params?.releaseType || undefined,
				excludeTakeDown: params?.excludeTakeDown || undefined,
			},
		}),
	getPlaylists: (id: string) =>
		// TODO : no idea so far how response look like
		get<DataResponseWrapper<any>>(endpoints.playlists(id)),
	getTopTracks: (artistId: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<ArtistTopTracks>>(endpoints.topTracks(artistId), {
			params: filters,
		}),
	getTopPlaylists: (artistId: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<ArtistTopPlaylists>>(
			endpoints.topPlaylists(artistId),
			{
				params: filters,
			},
		),
};

export default requests;
